import React from 'react';

export const IconDoorEntry: React.FC = () => (
  <svg
    className="icon-door-entry"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.12695 10.3291V27.0564"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1633 8.65625L6.12695 10.329"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1633 28.7294L6.12695 27.0566"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.1641 8.65625V28.729" stroke="#1D1D1B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M21.1822 27.0566H16.1641"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.1641 10.3291H21.1822"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.1826 27.0564V10.3291"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6543 17.8555V19.5282"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5281 10.3289C24.5281 8.47993 23.0315 6.9834 21.1826 6.9834"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.8735 10.3296C27.8735 6.63118 24.881 3.63867 21.1826 3.63867"
      stroke="#1D1D1B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
